<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(../../assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div>
           
            <!-- Form -->
            <div class="row">
                <div class="col-12">
                    <form verifyForm="ngForm">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">
                                        <span class="text-danger">*</span>Email Id</label>
                                    <input type="email" id="emailId" required #emailId="ngModel"
                                        name="emailId" [(ngModel)]="emailVerifyObj.emailId"
                                        pattern="[a-zA-Z0-9._]{2,}@[a-zA-Z]{2,}\.[a-zA-Z]{2,3}$"
                                        maxlength="40" class="form-control" placeholder="Email Id">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.required"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">This
                                        Field is Required</span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.pattern"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">Please
                                        Enter Valid Email </span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.maxlength || emailId?.errors.pattern"
                                        *ngIf="emailId.errors">
                                        valid email.</span>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label class="control-label">
                                    <span class="text-danger">*</span>OTP</label>
                                <div class="form-group">
                                    
                                    <input type="tel" id="OTP"    onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control" required #OTP="ngModel"
                                        name="OTP" [(ngModel)]="emailVerifyObj.OTP"
                                       placeholder="OTP">
                                    
                                </div>
                            </div>
                        </div>

                     
                      
                     
                        <div class="row form-group text-center">
                            <div class="col-12">
                                <a class="btn btn-block btn-lg bg-gradient-primary text-white" type="submit " (click)="verifyEmailAddress()">Submit
                                    </a>
                            </div>
                        </div>
                  
                    </form>
                </div>
            </div>
            <div *ngIf="show" class="row form-group mb-0 mt-2">
                <div class="col-12 text-center ">
                  Email Verified,please
                    <a href="#/ " class="text-primary ml-1">
                        <b>Sign In
                        </b>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>